<template>
  <el-card>
    <div class="toolbar">
      <el-button type="primary" @click="onCreateItem()">
        <i class="fas fa-fw fa-plus"></i> 新增工控机
      </el-button>
      <div class="former">
        <select2
          v-model="former.ipc_dgroup_ids"
          :multiple="true"
          clearable
          url="ipcdgroup"
          placeholder="请选择分组"
          no-data-text="未找到相关分组">
        </select2>&nbsp;
        <el-select v-model="former.Status" clearable placeholder="请选择工控机状态">
          <el-option
            v-for="(status, index) in $sys.DS_STATUS"
            :key="index"
            :label="status"
            :value="+index">
          </el-option>
        </el-select>&nbsp;
        <el-input
          v-model="former['Name|Mn|Sn:like']"
          placeholder="名称，MN，SN等"
          @keydown.enter.native="onSubmitQuery">
        </el-input>&nbsp;
        <el-button type="primary" @click="onSubmitQuery">
          <i class="fas fa-fw fa-search"></i>
        </el-button>
      </div>
    </div>

    <el-table :data="itemList" v-loading="loading" size="medium">
      <el-table-column type="index" :index="pager.size * (pager.page - 1) + 1"
        :width="Math.max(48, (pager.size * (pager.page)).toString().length * 12)">
      </el-table-column>
      <el-table-column prop="Name" label="工控机名称"></el-table-column>
      <el-table-column prop="Mn" label="MN号"></el-table-column>
      <el-table-column prop="Sn" label="工控机编号"></el-table-column>
      <el-table-column prop="Status" label="工控机状态" width="100">
        <template slot-scope="scope">
          <span>{{$sys.MS_STATUS[scope.row.Status]}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="Recipient" label="领用人"></el-table-column>
      <!-- <el-table-column prop="Dgroups" label="所属分组">
        <template slot-scope="scope">
          <el-tag
            v-for="group in scope.row.IpcDgroups"
            :key="group.ID"
            type="success"
            @close="onDeleteGroup(group, scope.row)"
            closable>
            {{group.Name}}
          </el-tag>
          <el-button size="mini" type="success" plain @click="onAddGroup(scope.row)"
            class="float-right" title="为该工控机增加分组">
            <i class="fas fa-plus"></i>
          </el-button>
        </template>
      </el-table-column> -->
      <el-table-column width="100" label="操作">
        <template slot-scope="scope">
          <el-button type="primary" @click.stop="onEditItem(scope.row)" title="编辑">
            <i class="fas fa-pencil-alt"></i>
          </el-button>
          <el-button type="danger" @click.stop="onDeleteItem(scope.row)" title="删除">
            <i class="fas fa-trash-alt"></i>
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="paginator">
      <el-pagination
        @current-change="onChangePage"
        layout="total, prev, pager, next"
        :total="pager.total"
        :current-page="pager.page"
        :page-size="pager.size">
      </el-pagination>
    </div>

    <el-dialog title="选择所属分组"
      :visible.sync="groupVisible"
      width="400px"
      top="5vh"
      @close="groupData.groupId = ''"
      :close-on-click-modal="false">
      <div class="clearfix">
        <div class="pull-left text-right pad-rgt" style="width: 75px; line-height: 30px;">选择分组：</div>
        <div style="margin-left: 90px;">
          <el-select v-model="groupData.groupId" placeholder="选择好分组" style="width: 100%;">
            <!-- eslint-disable vue/no-use-v-if-with-v-for -->
            <el-option
              v-for="(item, index) in groupList"
              v-if="groupSelected.indexOf(item.ID) === -1"
              :value="item.ID"
              :label="item.Name"
              :key="index">
            </el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="groupVisible = false">
          <i class="fas fa-times"></i> 取 消
        </el-button>
        <el-button type="primary" @click="onSaveJoinGroup" :disabled="!groupData.groupId">
          <i class="far fa-save"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <item-add-form v-model="item"
      :visible.sync="addItemVisible"
      @form:saved="getItemList">
    </item-add-form>
  </el-card>
</template>

<script>
import ItemAddForm from './index--add-form.vue';

export default {
  components: {
    ItemAddForm,
  },
  data() {
    return {
      itemList: [],
      item: this.getEmptyItem(),
      loading: false,
      former: {
        'Name|Mn|Sn:like': '',
        Status: '',
        ipc_dgroup_ids: [],
      },
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      // 新增出厂设置（新增工控机）
      addItemVisible: false,
      groupVisible: false,
      groupData: {
        deviceId: '',
        groupId: '',
      },
      groupList: [],
      groupSelected: [],
    };
  },
  mounted() {
    this.getItemList();
    this.getGroupList();
  },
  methods: {
    getItemList() {
      this.loading = true;
      this.$axios.get('ipcdevice', {
        params: {
          where: _.omit(this.former, 'ipc_dgroup_ids'),
          // where: this.former,
          ipc_dgroup_ids: this.former.ipc_dgroup_ids, // 特殊的搜索
          with: ['IpcDgroups'],
          ...this.pager,
        },
      }).then((response) => {
        this.itemList = response.data.data;
        this.pager = _.pick(response.data, 'size', 'page', 'total');
        if (this.pager.page > response.data.last) {
          this.pager.page = response.data.last;
          this.getItemList();
        }
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      }).finally(() => {
        this.loading = false;
      });
    },
    // 查询
    onSubmitQuery() {
      this.pager.page = 1;
      this.getItemList();
    },
    // 翻页
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    // 工控机出厂设置（新增）item置空
    getEmptyItem() {
      return {
        Name: '',
        Sn: '',
        PurchaseUnit: '',
        Recipient: '',
        SoftwareVersion: '',
        HardwareVersion: '',
        ProductionDay: null,
        Status: 1,
        Mn: '',
        Comment: '',
      };
    },
    onCreateItem() {
      this.item = this.getEmptyItem();
      this.addItemVisible = true;
    },
    onEditItem(row) {
      this.item = row;
      this.addItemVisible = true;
    },
    onDeleteItem(row) {
      this.$confirm('确定要删除此工控机吗？', '提示').then(
        () => this.$axios.delete(`ipcdevice/${row.ID}`)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除工控机');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 选择分组显示，提出已选的分组
    onAddGroup(row) {
      this.groupSelected = [];
      this.groupData.deviceId = row.ID;
      if (row.IpcDgroups !== null) {
        row.IpcDgroups.forEach((item) => {
          this.groupSelected.push(item.ID);
        });
      }
      this.groupVisible = true;
    },
    // 保存选择的分组
    onSaveJoinGroup() {
      const url = `ipcdgroup/${this.groupData.groupId}/ipcdevice/${this.groupData.deviceId}`;
      this.$axios.post(url).then(() => {
        this.$message.success('添加成功');
        this.getItemList();
        this.groupVisible = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 删除所属分组
    onDeleteGroup(group, device) {
      const url = `ipcdgroup/${group.ID}/ipcdevice/${device.ID}`;
      this.$confirm('确定要删除此分组吗？', '提示').then(
        () => this.$axios.delete(url)
      ).then(() => {
        this.getItemList();
        this.$message.success('成功删除');
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
    // 获取所有分组
    getGroupList() {
      this.$axios.get('ipcdgroup').then((response) => {
        this.groupList = response.data.data;
        this.loading = false;
      }).catch(({ response }) => {
        this.$sys.alarmResponse(response);
      });
    },
  },
};
</script>
